var r=n=>n.join(", ").replace(/, ([^,]*)$/," and $1");export{r as a};
